export const FETCH_ERROR_MESSAGE = 'Failed to fetch'
export const CONNECTION_ERROR_MESSAGE = 'Error de conexión. Reintentar.'
export const ATTENDANCE_ERROR_MESSAGE = 'Ocurrió un error. Reintentar.'